import { FirebaseServices, getFirebaseServices } from "@/services/firebase/config";
import { setGlobalFirebase } from "@/services/globals";
import { useEffect, useState } from "react";

//TODO - Do we even need this!?!
export function useFirebase() {
  const [services, setServices] = useState<FirebaseServices | undefined>(() => {
    try {
      const s = getFirebaseServices();
      setGlobalFirebase(s);
      return s;
    } catch (e) {
      console.warn("Firebase not ready on first render:", e);
      return undefined;
    }
  });

  useEffect(() => {
    if (services === undefined) {
      try {
        const s = getFirebaseServices();
        setGlobalFirebase(s);
        setServices(s);
      } catch (e) {
        console.error("Failed to initialize Firebase services in useEffect:", e);
      }
    }
  }, [services]);

  return services;
}
